﻿import $ from "jquery";
import "Fancybox";

var displayMode = {
	lightbox: "lightbox",
	popup: "popup"
};

export default function (microsite) {
	if (microsite.displayMode === displayMode.lightbox) {
		showLightBox(microsite);
	}

	if (microsite.displayMode === displayMode.popup) {
		showPopup(microsite);
	}
}

function showPopup(microsite) {
	window.open(
		microsite.url,
		"_blank",
		`width=${microsite.width},height=${microsite.height},location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no`);
}

function showLightBox(microsite) {

	const config = {
		src: microsite.url,
		smallBtn: false,
		touch: false,
		type: "iframe",
		iframe: {
			preload: false
		}
	};

	// CCSDT-8179
	if (ccs_util.isMobile()) {

		config.iframe.css = {
			"width": "100%",
			"height": "100%",
			"max-width": microsite.width + "px",
			"max-height": microsite.height + "px"
		}
	} else {
		config.width = microsite.width;
		config.height = microsite.height;
	}

	$.fancybox.open(config);
}
